import Axios from "axios";
import appConfig from "../config/AppConfig";
class EcommerService {
  static getList(data){
    return Axios.post( appConfig.ecommerceBaseUrl+ "admin/list_aps", data);
  }
  static getSucursal() {
    return Axios.get( appConfig.ecommerceBaseUrl+ "v1/catalogo/agencia");
  }
  static getCanales(user_id) {
    return Axios.get(appConfig.ecommerceBaseUrl+"admin/list_canales_user_id/"+user_id);
  }      
  static dowloadPdf(id) {
    return appConfig.ecommerceBaseUrl+`v1/cotization/quotation/${id}`
  }   
  static actionEnviar(id) {
    return Axios.get(appConfig.ecommerceBaseUrl+"Admin/action/" + id);
  }
  static actionCancelar(id) {
    return Axios.get(appConfig.ecommerceBaseUrl+ "Admin/cancelar/" + id);
  }
  static actionEnviarAccion(id, accion) {
    return Axios.get(appConfig.ecommerceBaseUrl+"Admin/actionSave/" + id + "/" + accion);
  }

};
export default EcommerService;